import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Card, CardContent } from '@mui/material';
import styles from './HomePageProductPage.module.css';
import { getCategory } from '../Services/Utils/ServiceProviderApis';
import { notifySet } from '../Services/Actions/CommonActions';
import { getImage } from '../Services/Utils/FileApis';

function HomePageProductPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const [category, setCategory] = useState({});
  const [serviceProviders, setServiceProviders] = useState([]);

  useEffect(() => {
    const data = {
      categoryView: {
        id: params.id
      },
      status: {
        id: 2
      }
    };
    getCategory(data.categoryView).then((res) => {
      const { message, hasError } = res;
      if (hasError === false) {
        setCategory(res.view);
        setServiceProviders(res.view.serviceProviderViews);
      } else if (hasError === true) {
        setCategory({});
        setServiceProviders([]);
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  }, [params]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <h6 className={styles.heading}>{category.name}</h6>
      </div>
      <div className="col-sm-12">
        <div className={styles['logo-title-card-box-con']}>
          <div className="row">
            {
              serviceProviders?.map((data, key) => (
                <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 d-flex" key={key}>
                  <div className={`${styles['logo-title-card-box-col']} same-box`}>
                    <Link
                      to={`/service-provider/${category.id}/${data.id}`}
                      className={styles['logo-title-card-box-full']}
                    >
                      <Card className={styles['product-card-box']}>
                        <CardContent
                          className={`${styles['product-card-content-box']}`}
                        >
                          {data.hasSubscribed ? <i className={`fa fa-star ${styles.checked}`} /> : ''}
                          <div className={styles['logo-title-card-box-img']}>
                            <img alt="" src={`${getImage(data.logoView)}`} />
                          </div>
                          <div className={styles['logo-title-card-box-text']}>
                            <p>{data.name}</p>
                          </div>
                        </CardContent>
                      </Card>
                    </Link>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePageProductPage;
